import axios from "axios";

const MEDIA_ITEM_REST_URL = "/web/rest-credit/media-item";
const BASE_URL = "/web/rest-credit";

export function getCalculationData() {
  return axios.get(`${BASE_URL}/monthly-amount-calculation-widget`).then(response => {
    if (response.data.resultCode !== 200) {
      Promise.reject(response.data);
    }

    return response.data.data;
  });
}

export function getMonthlyAmount(requestBody) {
  return axios
    .post(`${BASE_URL}/monthly-amount-calculation-widget?start-flow=false`, requestBody)
    .then(response => {
      if (response.data.resultCode !== 200) {
        Promise.reject(response.data);
      }

      return response.data.data;
    });
}

export function submitMonthlyAmount(requestBody) {
  return axios
    .post(`${BASE_URL}/monthly-amount-calculation-widget?start-flow=true`, requestBody)
    .then(response => {
      if (response.data.resultCode !== 200) {
        Promise.reject(response.data);
      }
      return response.data;
    });
}

/**
 * Retrieve BOFI article data based on given array of tags.
 */
export function getBofiArticle(...tags) {
  return axios
    .post(MEDIA_ITEM_REST_URL, {
      tags: tags,
      presentation: "bofi clean display on",
      mediaItemType: "bofipresentationBofiArticle",
      hideTitle: true,
    })
    .then(response => {
      return response.data;
    });
}

/**
 * Retrieve BOFI article meta data info based on given array of tags.
 */
export function getBofiArticleInfo(...tags) {
  return axios
    .get(
      `${MEDIA_ITEM_REST_URL}/info?type=bofipresentationBofiArticle&tags=${(tags || []).join(",")}`
    )
    .then(response => {
      return response.data;
    });
}

/**
 * Retrieve the maximum loan capacity based on income and costs.
 */
export function getMaximumLoanCapacity(requestDto) {
  return axios.post(`${BASE_URL}/maximum-loan-capacity`, requestDto).then(function(response) {
    return response.data.data;
  });
}
